import { JSX } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { RootState } from "../store/store"

interface ProtectedRouteProps {
  children: JSX.Element
  adminOnly?: boolean
}

export default function ProtectedRoute({ children, adminOnly = false }: ProtectedRouteProps) {
  const token = localStorage.getItem("token")
  const location = useLocation()
  const isAdmin = useSelector((state: RootState) => state.auth.user?.isAdmin ?? false)

  if (!token) {
    return <Navigate to={`/?message=not-logged-in&from=${encodeURIComponent(location.pathname)}`} />
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/home" replace />
  }

  return children
}


